import React, { Component } from 'react';

import PropTypes from 'prop-types';

import SearchBar from '../search/search-bar/index';

import { LoadingIndicator, Tile } from '../../components';
import Group from './group';
import theme from '../../app.theme';
import env from '../../../run-config';

class Courses extends Component {
  constructor(props) {
    super(props);

    this.courseBaseUrl = this.props.courseUrl || this.props.match.url;
    this.state = {};
    this.onSearch = this.onSearch.bind(this);
    this.onClickShare = this.onClickShare.bind(this);
  }

  onSearch(searchTerm) {
    this.props.navigate(`/search?searchTerm=${searchTerm}`);
  }

  loadCourse(course) {
    this.props.loadCourse(course);
    this.props.history.push(`${this.props.courseUrl || this.props.match.url}/${course.id}`);
  }

  renderCourseGroups(data) {
    return data.map(group => <Group
      key={group.id}
      group={group}
      pinOrUnpinContent={this.props.pinOrUnpinContent}
      onClick={this.loadCourse.bind(this)}
      onClickShare={this.onClickShare}
    />);
  }

  onClickShare(course) {
    const url = `${env.apiHost}/courses/${course.id}/all`;
    this.props.onExportContent(url);
  }

  render() {
    if (this.props.isLoading) {
      return <LoadingIndicator show centered />;
    }

    if (!this.props.groups) {
      return null;
    }

    const topLevelCourses = this.props.groups.filter(c => c.type == 'course');
    const data = this.props.groups.asMutable().filter(t => t.type == 'group' && t.children && t.children.length);

    if (topLevelCourses.length) {
      data.push({ name: 'Weitere Inhalte', children: topLevelCourses });
    }

    const searchBar = !this.props.disableSearch
    ? <SearchBar location={this.props.location} onSearch={this.onSearch} />
    : null;

    return (
      // <div className="col-lg-10 col-md-12 col-sm-12">
      <div>
        {searchBar}
        {this.renderCourseGroups(data)}
      </div>
    );
  }
}

export default Courses;



// WEBPACK FOOTER //
// ./src/app/main/courses/courses.js